import React from 'react';
import { metrics } from '@atlassian/browser-metrics';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';

export const projectVersionsPageLoad = metrics.pageLoad({
	key: 'project-versions',
	ssr: {
		doneAsFmp: true,
	},
	slo: {
		fmp: {
			initial: { threshold: 1000 },
			transition: { threshold: 1000 },
		},
		tti: {
			initial: { threshold: 4000 },
			transition: { threshold: 4000 },
		},
	},
});

export const PerformanceTracker = (): React.JSX.Element => (
	<SubmitApdex
		appName="jira-project-versions"
		// @ts-expect-error - TS2769 - No overload matches this call.
		metric={projectVersionsPageLoad}
	/>
);
